var map = {
	"./nature-1.svg": 67473,
	"./nature-2.svg": 53352,
	"./nature-3.svg": 42745,
	"./nature-4.svg": 87501,
	"./nature-5.svg": 64918,
	"assets/images/leads/nature/nature-1.svg": 67473,
	"assets/images/leads/nature/nature-2.svg": 53352,
	"assets/images/leads/nature/nature-3.svg": 42745,
	"assets/images/leads/nature/nature-4.svg": 87501,
	"assets/images/leads/nature/nature-5.svg": 64918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 947;